;(function() {
  'use strict'

  Controller.$inject = ["$q", "glAnalytics", "glDialog", "glToast", "glPrefs", "api", "channelService", "responseService", "accountService", "subscriberService", "translationService", "externalPanelService", "uacService", "userService", "surveyReport", "responseFilterService", "surveyServiceNext", "featureService", "quotaMigrationService", "quotaSaveService", "ResponseFilter", "StateFactory"];
  angular.module('app.core').component('surveyChannels', {
    controller: Controller,
    templateUrl: 'survey-channels.html',
    bindings: {
      survey: '<',
      translations: '<',
      onDirtyChange: '&',
      quotaManagerDirty: '<',
      quotaSetupUnsaved: '<',
      onQuotaManagerDirtyChange: '&',
      onQuotaSetupUnsavedChange: '&',
      initialTab: '<',
      onInitialTabConsumed: '&',
      onDiscardQuotaChanges: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $q,
    glAnalytics,
    glDialog,
    glToast,
    glPrefs,
    api,
    channelService,
    responseService,
    accountService,
    subscriberService,
    translationService,
    externalPanelService,
    uacService,
    userService,
    surveyReport,
    responseFilterService,
    surveyServiceNext,
    featureService,
    quotaMigrationService,
    quotaSaveService,
    ResponseFilter,
    StateFactory
  ) {
    var ctrl = this
    var quotaSetupPrefs = glPrefs.create('quota-manager')
    var QUOTA_SETUP_PREFS_OPTIONS = { user: true }

    function getQuotaSetupPrefsKey() {
      return 'setup-shown-' + ctrl.survey.id
    }

    ctrl.channelState = new StateFactory(['loading', 'zero', 'list', 'error'])

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.setTab = setTab

    ctrl.addChannel = addChannel
    ctrl.removeChannel = removeChannel
    ctrl.onChannelSaved = onChannelSaved

    ctrl.getSelectedResponses = getSelectedResponses
    ctrl.isAllResponsesSelected = isAllResponsesSelected
    ctrl.toggleSelectAllResponses = toggleSelectAllResponses
    ctrl.editResponseFilter = editResponseFilter
    ctrl.manageSegment = manageSegment
    ctrl.deselectResponses = deselectResponses
    ctrl.deleteSelectedResponses = deleteSelectedResponses
    ctrl.deleteResponses = deleteResponses
    ctrl.exportDeletedResponses = exportDeletedResponses
    ctrl.showExportResponsesDialog = showExportResponsesDialog
    ctrl.viewResponse = viewResponse
    ctrl.setQuotaManagerDirty = setQuotaManagerDirty

    function onInit() {
      applyTab(ctrl.initialTab || 'channels')
      if (ctrl.initialTab) ctrl.onInitialTabConsumed()
      ctrl.subscriber = subscriberService.getSubscriber()
      ctrl.isSSR = userService.isSSR()
      ctrl.corpus = translationService.corpus(ctrl.survey.serialize())
      ctrl.canUseTagQuotas = featureService.canUseTagQuotas()

      ctrl.channelState.loading()
      $q.all([loadExternalPanelProviders(), loadChannels()]).then(function() {
        updateChannelState()
        buildQuotaSetup()
      })

      glAnalytics.track(
        'channel',
        'view-audiences-tab',
        ctrl.survey.id + ' - ' + ctrl.survey.title
      )
    }

    function onChanges(changes) {
      if (changes.survey && !changes.survey.isFirstChange()) {
        ctrl.onQuotaManagerDirtyChange({ $dirty: false })

        ctrl.onQuotaSetupUnsavedChange({ $unsaved: false })
      }

      if (isQuotaDeferralReleased(changes)) {
        syncLegacyTagQuotasFlag()
      }
    }

    function isQuotaDeferralReleased(changes) {
      var dirtyChange = changes.quotaManagerDirty
      var setupChange = changes.quotaSetupUnsaved

      var dirtyReleased =
        !!dirtyChange &&
        !dirtyChange.isFirstChange() &&
        !dirtyChange.currentValue
      var setupReleased =
        !!setupChange &&
        !setupChange.isFirstChange() &&
        !setupChange.currentValue

      if (!dirtyReleased && !setupReleased) return false

      var dirtyNow = dirtyChange
        ? dirtyChange.currentValue
        : ctrl.quotaManagerDirty
      var setupNow = setupChange
        ? setupChange.currentValue
        : ctrl.quotaSetupUnsaved

      if (dirtyNow || setupNow) return false

      if (!ctrl.channels || ctrl.channelsLoading || ctrl.channelsError) {
        return false
      }

      return true
    }

    function setQuotaManagerDirty(dirty) {
      ctrl.onQuotaManagerDirtyChange({ $dirty: dirty })
      ctrl.onDirtyChange({ $dirty: dirty })

      if (!dirty) ctrl.onQuotaSetupUnsavedChange({ $unsaved: false })
    }

    function buildQuotaSetup() {
      if (!ctrl.canUseTagQuotas) return

      if (_.some(ctrl.channels, { tagQuotasEnabled: true })) return

      if (_.isArray(ctrl.survey.quotaPlans)) return

      var plan = quotaMigrationService.buildPlan(ctrl.survey, ctrl.channels)
      if (!plan) return

      ctrl.survey.quotaPlans = [plan]

      ctrl.onQuotaSetupUnsavedChange({ $unsaved: true })

      if (
        quotaSetupPrefs.get(
          getQuotaSetupPrefsKey(),
          QUOTA_SETUP_PREFS_OPTIONS
        ) === true
      ) {
        return
      }

      quotaSetupPrefs.set(
        getQuotaSetupPrefsKey(),
        true,
        QUOTA_SETUP_PREFS_OPTIONS
      )

      ctrl.tab = 'quotas'
      showQuotaSetupDialog()
    }

    function showQuotaSetupDialog() {
      glDialog
        .alert(
          'Your quotas have moved',
          'Tag quotas are now part of the Quota Manager, on this tab. Your ' +
            'existing quotas are already set up below — same caps, same ' +
            'progress.\n\n' +
            'Take a look, then press Save to keep this setup. Your survey ' +
            'enforces the same quotas either way; saving just switches it over ' +
            'to the new screen.',
          { locals: { closeText: 'Take a look' } }
        )
        .catch(_.noop)
    }

    function setTab(tab) {
      if (ctrl.tab === 'quotas' && tab !== 'quotas' && ctrl.quotaManagerDirty) {
        promptUnsavedQuotaChanges(tab)
        return
      }
      applyTab(tab)
    }

    function applyTab(tab) {
      if (tab === 'responses') {
        ctrl.hasInitResponses = true
        loadResponses()
      }
      ctrl.tab = tab
    }

    function promptUnsavedQuotaChanges(tab) {
      if (ctrl.quotaSwitchSaving) return

      // prettier-ignore
      var template = [
        '<gl-dialog class="alert-dialog">',
          '<div class="alert-dialog__content">',
            '<div class="alert-dialog__title">Unsaved quota changes</div>',
            '<div class="alert-dialog__message">',
              'You have quota changes that have not been saved.',
            '</div>',
          '</div>',
          '<div class="alert-dialog__actions">',
            '<g-btn class="alert-dialog__action" ',
              'label="Save and switch" ',
              'on-click="dialog.close(\'save\')"></g-btn>',
            '<g-btn class="alert-dialog__action" ',
              'label="Discard and switch" ',
              'secondary="true" ',
              'on-click="dialog.close(\'discard\')"></g-btn>',
            '<g-btn class="alert-dialog__action" ',
              'label="Cancel" ',
              'secondary="true" ',
              'on-click="dialog.cancel()"></g-btn>',
          '</div>',
        '</gl-dialog>',
      ]

      glDialog
        .show({
          template: template.join(''),
          clickOutsideToClose: true,
          escapeToClose: true,
        })
        .then(function(action) {
          if (action === 'save') return saveAndSwitch(tab)
          if (action === 'discard') return discardAndSwitch(tab)
        })

        .catch(_.noop)
    }

    function saveAndSwitch(tab) {
      ctrl.quotaSwitchSaving = true
      return quotaSaveService
        .save(ctrl.survey)
        .then(function() {
          setQuotaManagerDirty(false)
          applyTab(tab)
        })
        .finally(function() {
          ctrl.quotaSwitchSaving = false
        })
    }

    function discardAndSwitch(tab) {
      ctrl.onDiscardQuotaChanges({ $tab: tab })
    }

    function loadExternalPanelProviders() {
      return externalPanelService.list()
    }

    function loadChannels() {
      return channelService.getBySurvey(ctrl.survey.id, function(
        channels,
        loading,
        error
      ) {
        ctrl.channels = channels
        ctrl.channelsLoading = loading
        ctrl.channelsError = error
      })
    }

    function loadResponses(forceLoading) {
      if (forceLoading) {
        ctrl.responses = null
      }
      ctrl.responsesError = false
      return loadDimensions()
        .then(function() {
          var filter = ctrl.filter ? ctrl.filter.toMongo() : null
          console.log('filter', JSON.stringify(filter, null, 2))
          return responseService
            .list(ctrl.survey.id, filter)
            .then(function(responses) {
              ctrl.responses = responses
            })
        })
        .catch(function(err) {
          ctrl.responsesError = true
          console.error(err)
        })
    }

    function loadDimensions() {
      if (ctrl.dimensions) return $q.resolve()
      // HACK: we need to fetch an entire report so that we can extract
      // the dimensions which are then used in filters
      return api.surveyReports
        .get({ id: ctrl.survey.id, filter: { type: 'COMPLETE' } })
        .then(function(report) {
          ctrl.dimensions = responseFilterService.extractDimensionsFromReport(
            report
          )
        })
    }

    function addChannel() {
      if (!uacService.canManageChannels(true)) return
      ctrl.tab = 'channels'
      channelService
        .showPicker({ surveyId: ctrl.survey.id })
        .then(function(channel) {
          var currency = ctrl.subscriber.billing.currency
          if (channel.type === channel.Type.PANEL && !currency) {
            return accountService.showPurchaseDialog({
              type: 'add-payment-method',
              context: 'add-panel-channel',
            })
          }
          if (channel.type === channel.Type.PANEL) {
            channel.panel.lengthOfInterview.become(
              ctrl.survey.lengthOfInterview
            )
          }
          channel.name = 'C' + (ctrl.channels.length + 1) + '. ' + channel.name
          ctrl.channels.unshift(channel)
        })
        .finally(updateChannelState)
    }

    function removeChannel(channel) {
      _.remove(ctrl.channels, { id: channel.id })
      updateChannelState()
      syncLegacyTagQuotasFlag()
    }

    function onChannelSaved() {
      syncLegacyTagQuotasFlag()
    }

    function syncLegacyTagQuotasFlag() {
      if (!ctrl.canUseTagQuotas) return

      var settings = ctrl.survey.tagQuotaSettings
      var derived = !_.some(ctrl.channels, { tagQuotasEnabled: true })

      if (derived === settings.enabled) return

      if (ctrl.quotaManagerDirty || ctrl.quotaSetupUnsaved) {
        // a survey save here would also persist unsaved quota edits, so let the next channel save converge it
        return
      }

      settings.enabled = derived
      surveyServiceNext.save(ctrl.survey).catch(function() {
        glToast.show(
          'Error updating quotas. Please try again later or contact support.'
        )
      })
    }

    function updateChannelState() {
      if (ctrl.channelsError) {
        ctrl.channelState.error()
      } else if (!ctrl.channels.length && ctrl.channelsLoading) {
        ctrl.channelState.loading()
      } else if (!ctrl.channels.length) {
        ctrl.channelState.zero()
      } else if (ctrl.channels.length) {
        ctrl.channelState.list()
      }
    }

    function getSelectedResponses() {
      if (!ctrl.responses) return []
      return ctrl.responses.filter(function(response) {
        return response.selected
      })
    }

    function isAllResponsesSelected() {
      var selected = getSelectedResponses().length
      return selected > 0 && selected === ctrl.responses.length
    }

    function toggleSelectAllResponses() {
      var value = isAllResponsesSelected() ? false : true
      ctrl.responses.forEach(function(response) {
        response.selected = value
      })
    }

    function editResponseFilter() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="response-filter-dialog__dialog">',
          '<response-filter-dialog ',
            'survey="survey" ',
            'channels="channels" ',
            'dimensions="dimensions" ',
            'filter="filter" ',
            'on-apply="dialog.close($filter)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      // if we dont have a filter create one
      // if we already have one, clone it so it can be edited discretely
      var filter
      if (ctrl.filter) {
        filter = ctrl.filter.clone()
      } else {
        filter = new ResponseFilter(ctrl.survey)
        filter.init()
      }
      glDialog
        .show({
          template: template.join(' '),
          clickOutsideToClose: false,
          escapeToClose: true,
          locals: {
            survey: ctrl.survey,
            channels: ctrl.channels,
            dimensions: ctrl.dimensions,
            filter: filter,
          },
        })
        .then(function(filter) {
          // if no filter is supplied this means the user clicked "remove"
          ctrl.filter = filter
          loadResponses(true)
        })
    }

    function manageSegment() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="segment-manager__dialog">',
          '<segment-manager',
            'survey-id="surveyId" ',
            'on-cancel="dialog.cancel()" ',
            'on-complete="dialog.close($newSegments)" ',
          '/>',
        '</gl-dialog>'
      ]
      glDialog
        .show({
          template: template.join(' '),
          locals: {
            surveyId: ctrl.survey.id,
          },
        })
        .then(function(newSegments) {
          ctrl.survey.segments = newSegments
          surveyReport.modifyCachedSurvey(ctrl.survey.id, function(survey) {
            survey.segments = newSegments
          })
        })
    }

    function deselectResponses() {
      ctrl.responses.forEach(function(response) {
        response.selected = false
      })
    }

    function deleteSelectedResponses() {
      var responseIds = getSelectedResponses().map(function(response) {
        return response.id
      })
      deleteResponses(responseIds)
    }

    function deleteResponses(selectedIds) {
      if (!uacService.canManageAnalysisResponses(true)) return
      // prettier-ignore
      var template = [
        '<gl-dialog class="response-delete-dialog__dialog">',
          '<response-delete-dialog ',
            'survey-id="surveyId" ',
            'selected-ids="selectedIds" ',
            'on-cancel="dialog.cancel()" ',
            'on-done="dialog.close()" ',
          '/>',
        '</gl-dialog>',
      ]
      glDialog
        .show({
          template: template.join(' '),
          clickOutsideToClose: true,
          escapeToClose: true,
          locals: {
            surveyId: ctrl.survey.id,
            selectedIds: selectedIds,
          },
        })
        .then(function() {
          loadResponses()
        })
    }

    function exportDeletedResponses() {
      surveyReport.createExport({
        surveyId: ctrl.survey.id,
        deleted: true,
        withDuration: ctrl.isSSR && ctrl.subscriber.data.withDurationExport,
      })
    }

    function showExportResponsesDialog() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="export-responses-dialog__dialog">',
          '<export-responses-dialog ',
            'survey="survey" ',
            'channels="channels" ',
            'on-close="dialog.close()" ',
          '/>',
        '</gl-dialog>',
      ]
      glDialog.show({
        template: template.join(' '),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
          channels: ctrl.channels,
        },
      })
    }

    function viewResponse(e, response) {
      if (e.defaultPrevented) return
      if (!uacService.canViewAnalysisResponses(true)) return
      // prettier-ignore
      var template = [
        '<gl-dialog class="response-details-dialog__dialog">',
          '<response-details-dialog ',
            'survey="survey" ',
            'response-id="responseId" ',
            'on-close="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]
      glDialog.show({
        template: template.join(' '),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          survey: ctrl.survey,
          responseId: response.id,
        },
      })
    }
  }
})()
